import GenericTable from '../../../../cars/components/V3/_shared/GenericTable/GenericTable'
import fleetReportTableData from './fleetReportTableData'
import type { Fleet } from '../../../../../types'
import type { Row } from '@tanstack/react-table'
import { formatNumber } from '../../utils/formatNumber'
import TableMobileCardContent from '../../../../cars/components/V3/_shared/GenericTable/TableMobileCardContent'

type FleetReportTableProps = {
  data: Fleet[]
  isLoading?: boolean
}

function FleetReportTable({ data, isLoading }: FleetReportTableProps) {
  const columns = fleetReportTableData()

  return (
    <GenericTable
      className="max-h-[50vh]"
      isLoading={isLoading}
      data={data}
      columns={columns}
      mobileCardContent={(row) => {
        return <MobileCardContent row={row as Row<Fleet>} />
      }}
    />
  )
}

export default FleetReportTable

function MobileCardContent({ row }: { row: Row<Fleet> }) {
  const settings = { digits: { min: 0, max: 0 }, prefix: 'kr ' }

  const {
    maxKm,
    regNo,
    totalKm,
    budgetKm,
    termsNow,
    fixedYear,
    totalYear,
    driverName,
    totalTerms,
    nonFixedYear,
    totalContract,
    accountStatus,
    fixedContract,
    nonFixedContract,
  } = row.original

  const data = [
    {
      label: 'Regnr',
      value: regNo || '',
    },
    {
      label: 'Sjåfør',
      value: driverName || '',
    },
    {
      label: 'Status',
      value: accountStatus === 'AVVIKLET' || accountStatus === 'ADM' ? 'ADM' : String(termsNow || ''),
    },
    {
      label: 'Leieperiode',
      value: totalTerms || '',
    },
    {
      label: 'KM PT',
      value: formatNumber(totalKm, settings),
    },
    {
      label: 'KM simulert',
      value: formatNumber(budgetKm, settings),
    },
    {
      label: 'Maks km',
      value: formatNumber(maxKm, settings),
    },
    {
      label: 'Faste kostnader hittil',
      value: formatNumber(fixedYear, settings),
    },
    {
      label: 'Faste kostnader',
      value: formatNumber(fixedContract, settings),
    },
    {
      label: 'Variable kostnader hittil',
      value: formatNumber(nonFixedYear, settings),
    },
    {
      label: 'Variable kostnader',
      value: formatNumber(nonFixedContract, settings),
    },
    {
      label: 'Totale kostnader hittil',
      value: formatNumber(totalYear, settings),
    },
    {
      label: 'Totale kostnader',
      value: formatNumber(totalContract, settings),
    },
  ]
  const header = `Fleet - ${regNo}`
  return <TableMobileCardContent header={header} data={data} />
}
